export { default } from './TextDesplegable';
